import { Module } from "vuex";

import { IRootState } from "@/store";
import { getters } from "@/store/modules/company/getters";
import { actions } from "@/store/modules/company/actions";
import { mutations } from "@/store/modules/company/mutations";
import { ICompanyState, state } from "@/store/modules/company/state";

export const company: Module<ICompanyState, IRootState> = {
  actions,
  mutations,
  state,
  getters,
};
